<template>
  <v-menu
    :close-on-content-click="false"
    rounded="lg"
    :value="isOpened"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="n-white-btn n-small-btn n-icon-btn primary--text"
        v-on="on"
        @click="isOpened = true"
      >
        <v-icon style="font-size: 20px;">dashboard</v-icon>
      </v-btn>
    </template>
    <n-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <div class="font-weight-bold">Type d'affichage souhaité</div>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn
              icon
              @click="isOpened = false"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item
          v-for="layout in availableLayouts"
          :key="layout.id"
          @click="setLayout(layout)"
        >
          <v-list-item-icon class="mt-3 mb-3">
            <v-icon
              color="primary darken-2"
              v-if="currentLayout === layout.id"
            >
              check
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            {{ layout.label }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </n-card>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    isOpened: true,
  }),

  computed: {
    ...mapState(`ui/interventions`, [
      `availableLayouts`,
    ]),
    currentLayout: {
      get() { return this.$store.getters[`ui/interventions/currentLayout`]; },
      set(layout) { this.$store.commit(`ui/interventions/SET_LAYOUT`, layout.id); },
    },
  },

  methods: {
    setLayout(layout) {
      this.currentLayout = layout;
      this.isOpened = false;
    },
  },

  beforeMount() {
    this.isOpened = false;
  },
};
</script>

<style lang="scss">
</style>
